import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycWhatAreTheTopMisconceptionsAboutTheProbateProcessPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-what-are-the-top-misconceptions-about-the-probate-process/']} />;
}
